import * as getList from './reducers/get-list';
import * as getSportLadder from './reducers/getSportLadder';
import * as updateSportLadder from './reducers/updateSportLadder';
import * as copySportLadder from './reducers/copySportLadder';

import * as getMaster from './reducers/masterLadder/get';
import * as createMasterLadderPrice from './reducers/masterLadder/createPrice';
import * as updateMasterLadderPrice from './reducers/masterLadder/updatePrice';
import * as deleteupdateMasterLadderPrice from './reducers/masterLadder/deletePrice';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    LADDERS_GET_LIST_REQUEST: getList.request,
    LADDERS_GET_LIST_ERROR: getList.error,
    LADDERS_GET_LIST_FINISH: getList.finish,

    LADDER_GET_REQUEST: getSportLadder.request,
    LADDER_GET_ERROR: getSportLadder.error,
    LADDER_GET_FINISH: getSportLadder.finish,

    LADDER_UPDATE_REQUEST: updateSportLadder.request,
    LADDER_UPDATE_ERROR: updateSportLadder.error,
    LADDER_UPDATE_FINISH: updateSportLadder.finish,

    LADDER_COPY_REQUEST: copySportLadder.request,
    LADDER_COPY_ERROR: copySportLadder.error,
    LADDER_COPY_FINISH: copySportLadder.finish,

    //Master Ladder CRUD
    LADDERS_GET_MASTER_REQUEST: getMaster.request,
    LADDERS_GET_MASTER_ERROR: getMaster.error,
    LADDERS_GET_MASTER_FINISH: getMaster.finish,

    LADDERS_CREATE_PRICE_REQUEST: createMasterLadderPrice.request,
    LADDERS_CREATE_PRICE_ERROR: createMasterLadderPrice.error,
    LADDERS_CREATE_PRICE_FINISH: createMasterLadderPrice.finish,

    LADDERS_UPDATE_PRICE_REQUEST: updateMasterLadderPrice.request,
    LADDERS_UPDATE_PRICE_ERROR: updateMasterLadderPrice.error,
    LADDERS_UPDATE_PRICE_FINISH: updateMasterLadderPrice.finish,

    LADDERS_DELETE_PRICE_REQUEST: deleteupdateMasterLadderPrice.request,
    LADDERS_DELETE_PRICE_ERROR: deleteupdateMasterLadderPrice.error,
    LADDERS_DELETE_PRICE_FINISH: deleteupdateMasterLadderPrice.finish,
});
